export default __webpack_public_path__ + "static/media/ARROW_DOWN.4ca2ad02.png";